export default __webpack_public_path__ + "21bc2bd2909b9ed65df37d41fca6295b.png";